import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ShareDocumentDetail } from "../ShareDocumentDetail";
import { RaffleIcon } from "../../../assets/image/RaffleIcon";
import { RebootIcon } from "../../../assets/image/RebootIcon";
import {
  ENG_LANGUAGE,
  MONTH_ENG_LANGUAGE,
  MONTH_SRB_LANGUAGE,
  REFINE_OPTIONS,
} from "../../../utils/variables";
import {
  fetchDeleteDocumentNotification,
  fetchDocumentNotification,
} from "../../../api/notificationApi";

export function ShareDocumentContent() {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [isCheck, setIsCheck] = useState(true);
  const [notificationData, setNotificationData] = useState([]);
  const [view, setView] = useState("");
  const [deleteList, setDeleteList] = useState([]);
  const [recived, setRecived] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [refine, setRefine] = useState({
    threedays: "",
    withinweek: "",
    twofourday: "",
    withinmonth: "",
  });

  const navigate = useNavigate();
  const slugData = useParams();

  let data = slugData.name;
  const month =
    language === ENG_LANGUAGE ? MONTH_ENG_LANGUAGE : MONTH_SRB_LANGUAGE;

  const fetchNotificationData = async () => {
    setNotificationData([]);
    try {
      const result = await fetchDocumentNotification(refine);
      setNotificationData(result.data.getdcumentnotificationlist);
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  const handleSelectElement = () => {
    const ele = document.getElementsByName("chk");
    notificationData.map((data) => {
      deleteList.push(data.id);
    });
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = true;
    }
  };
  const handleDeselectElement = () => {
    const ele = document.getElementsByName("chk");
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = false;
    }
    setDeleteList([]);
  };

  const handleDeleteSelect = (a) => {
    let sum = false;
    deleteList.map((e) => {
      if (e == a) {
        sum = true;
        const index = deleteList.indexOf(a);
        if (index > -1) {
          deleteList.splice(index, 1);
        }
      }
    });
    if (sum == false) {
      deleteList.push(a);
    }
  };

  const handleDeleteDocument = async () => {
    try {
      await fetchDeleteDocumentNotification(deleteList);
      fetchNotificationData();
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };

  const handleRefineDay = (e) => {
    setRefine({
      threedays: e == "3" ? true : "",
      withinweek: e == "7" ? true : "",
      twofourday: e == "24" ? true : "",
      withinmonth: e == "30" ? true : "",
    });
    setIsCheck(true);
  };

  useEffect(() => {
    if (isCheck) {
      fetchNotificationData();
      setIsCheck(false);
    }

    setView(data ? data : "");
  }, [isCheck, notificationData, view, data, slugData]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setRecived("text-refine");
    }
  }, []);

  return (
    <div>
      {view == "" ? (
        <>
          <div class="main-header">
            <h2 className="border">{t("shared-documents")}</h2>
            <div class="mail-header-bar">
              <p>
                {notificationData.length} {t("shared-documents")}
              </p>
              <div class="btn-group flex">
                {t("text-refine")}
                <div className="select">
                  <label onClick={(e) => setIsActive(!isActive)}>
                    {t(recived)}
                    <span>
                      <img src="/images/done_a.svg" />
                    </span>
                  </label>
                  {isActive && (
                    <ul>
                      {REFINE_OPTIONS.map((option) => (
                        <li
                          key={option.label}
                          onClick={() => {
                            setRecived(t(option.label));
                            handleRefineDay(option.value);
                            setIsActive(!isActive);
                          }}
                        >
                          {t(option.label)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div class="mail-option">
              <div class="chk-all">
                <input
                  type="checkbox"
                  class="mail-radio mail-group-radio"
                  name="chk"
                  id="checkbox_id"
                  onClick={(e) => {
                    if (e.target.checked) {
                      handleSelectElement();
                    } else {
                      handleDeselectElement();
                    }
                  }}
                />
                <span className="circle"></span>
                <label for="checkbox_id">{t("select-all")}</label>
              </div>
              <div class="right-side-btn">
                <div class="delete-btn" onClick={(e) => handleDeleteDocument()}>
                  <a href="#">
                    <RaffleIcon />
                    <span> {t("text-delete")}</span>
                  </a>
                </div>
                <div
                  class="refresh-btn"
                  onClick={(e) => fetchNotificationData()}
                >
                  <a href="#">
                    <RebootIcon />
                  </a>
                  <span>{t("text-refresh")}</span>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-inbox table-hover">
            <tbody>
              {notificationData.map((data) => {
                return (
                  <tr
                    class={
                      data.parents_shareddocreadstatus == 0 ? "unread" : ""
                    }
                  >
                    <td class="view-message  dont-show">
                      <input
                        type="checkbox"
                        class="mail-radio"
                        name="chk"
                        onChange={(e) => handleDeleteSelect(data.id)}
                      />
                      <span className="circle"></span>
                      <span
                        onClick={(e) => {
                          navigate(
                            "/search-parents/" + slugData.id + "/" + data.INV_ID
                          );
                          setView(data.INV_ID);
                        }}
                      >
                        {data.parents_shareddocreadstatus == 0 ? (
                          <span class="new-tag"> {t("text-new-up")}</span>
                        ) : (
                          ""
                        )}
                        <span
                          class="username-text"
                          onClick={(e) => {
                            navigate(
                              "/search-parents/" + slugData.id + "/" + data.INV_ID
                            );
                            setView(data.INV_ID);
                          }}
                        >
                          
                          {data.ParentsName}
                        </span>
                        {t("has just shared")}
                        <strong>
                          {data?.documment_name
                            .substr(data?.documment_name.lastIndexOf("\\") + 1)
                            .split("[")[1]
                            ? JSON.parse(data?.documment_name).map(
                                (e, i) =>
                                  t(e) +
                                  (i + 1 ==
                                  JSON.parse(data?.documment_name).length
                                    ? ""
                                    : " , ")
                              )
                            : t(data?.documment_name)}
                        </strong>
                      </span>
                    </td>
                    <td class="view-message  text-right">
                      {month[new Date(data.documentsend_date).getMonth()] +
                        " " +
                        new Date(data.documentsend_date).getDate()}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <ShareDocumentDetail
          id={view}
          setview={setView}
          list={fetchNotificationData}
        />
      )}
    </div>
  );
}
